module.exports = __webpack_public_path__ + "static/media/NodeJS_Badge.3ea0359f.png";